import styled, { css } from 'styled-components';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const breakpoints = {
    desktop: '1599px',
    sDesktop: '1365px',
    tablet: '1023px',
    mobile: '767px',
};

export const Wrapper = styled.div<{ isAuth: boolean, isFixed: boolean, withPlank: boolean }>`
    display: block;
    position: ${p => p.isFixed ? 'fixed' : 'absolute'};
    width: 100%;
    height: ${p => p.isFixed ? '48px' : '74px'};
    font-family: ${FONTS.regular};
    box-shadow: ${p => p.isFixed ? '0 8px 20px -2px rgb(41 44 48 / 10%)' : '0 0 0'};
    top: 0;
    left: 0;
    background: ${COLORS.lightGrey};
    z-index: 11;

    a {
        font-family: ${FONTS.regular};
    }
    
    @media (max-width: ${breakpoints.sDesktop}) {
        position: fixed;
        top: ${p => p.withPlank ? '72px' : '0'};
        height: 72px;
    }
    
    &:after {
        content: '';
        position: absolute;
        width: 100%;
        top: ${p => p.isFixed ? 0 : '26px'};
        left: 0;
        height: 48px;
        background: ${COLORS.white};
        z-index: 0;

        @media (max-width: ${breakpoints.tablet}) {
            top: 24px;
        }
    }

    ${p => p.isAuth && css`
        padding: 0 90px;
        @media (max-width: 1024px) {
            padding: 0 50px;
        }
        @media (max-width: 640px) {
            padding: 0 18px;
        }
    `}
`;

export const HeaderWrapper = styled(GridContainer)<{ isAuth: boolean }>`
    display: block;
    min-width: 288px;
    position: relative;

    ${p => p.isAuth && css`
        @media (max-width: 1599px) {
            width: 100%;
            max-width: 1360px;
            padding: 0;
        }
    `}
`;

export const TopWrapper = styled.div<{ isFixed: boolean }>`
    display: ${p => p.isFixed ? 'none' : 'flex'};
    height: 26px;
    background: ${COLORS.lightGrey};
    font-size: 10px;
    color: ${COLORS.darkGrey};
    
    a {
        color: ${COLORS.darkGrey};
        transition: 0.3s color ease;
        
        &:hover {
            color: ${COLORS.red};
        }

        @media (max-width: ${breakpoints.mobile}) {
            color: ${COLORS.black};
        }
    }

    @media (max-width: ${breakpoints.sDesktop}) {
        display: flex;
        padding-left: 0;
        height: 24px;
    }
`;

export const MainWrapper = styled.div`
    position: relative;
    z-index: 11;
    height: 48px;
    align-items: center;
    flex-wrap: nowrap;

    @media(max-width: ${breakpoints.sDesktop}) {
        padding-left: 0;
        align-items: center;
    }
`;

export const DesktopBlock = styled.div`
    width: 100%;
    @media (max-width: ${breakpoints.sDesktop}) {
        display: none;
    }
`;

export const TabletBlock = styled.div`
    display: none;

    @media (max-width: ${breakpoints.sDesktop}) {
        display: flex;
        width: 100%;
    }
`;

export const MobileBlock = styled.div`
    display: none;
    
    @media (max-width: ${breakpoints.mobile}) {
        display: flex;
    }
`;

export const Logo = styled.div`
    width: auto;
    margin-right: 20px;

    @media (max-width: 1279px) {
        margin-right: 15px;
    }
    
    @media(max-width: ${breakpoints.sDesktop}) {
        margin-right: 0;
    }

    @media (max-width: 375px) {
        height: auto;
    }
    
    a {
        display: inline-block;
        height: 32px;
        border-radius: 4px;
        overflow: hidden;

        @media (max-width: 859px) {
            width: initial;
            margin: 0;
        }

        img {
            height: 100%;
        }
    }
`;

export const TopMenuBlock = styled.div`
    width: 51%;
    justify-content: space-between;
    font-size: 14px;
    line-height: 1.43;

    @media (max-width: ${breakpoints.mobile}) {
        width: 81vw;
        margin-bottom: 9px;
        font-size: 12px;
        line-height: 1.17;
        justify-content: flex-start;
    }
`;

export const TopMenuItem = styled.div`
    position: relative;
    margin-right: 12px;
    align-self: center;
    transition: 0.3s color ease;

    &:hover {
        color: ${COLORS.red};
    }

    &:hover>div {
        height: auto;
        padding: 22px 16px 16px;
        display: flex;
    }

    &:last-child {
        margin-right: 0;
    }

    @media (max-width: ${breakpoints.sDesktop}) {
        a {
            color: ${COLORS.darkGrey}
        }
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-right: 16px;
        margin-bottom: 16px;
    }
`;

export const CollapsedTopMenuItem = styled(TopMenuItem)`
    position: relative;
    cursor: pointer;
    padding-right: 12px;

    &:after {
        content: '';
        position: absolute;
        top: 3px;
        right: 0;
        width: 8px;
        height: 4px;
        transform-origin: center;
        background: url(${require('~/static/images/menu/arrow.svg')}) center / cover no-repeat;
    }

    &:hover {
        &:after {
            transform: rotate(180deg);
        }
    }

    @media (max-width: ${breakpoints.sDesktop}) {
        color: ${COLORS.darkGrey};
        padding-right: 16px;

        &:after {
            top: 8px;
        }
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-bottom: 16px;

        &:after {
            top: 5px;
        }
    }
`;

export const CollapsedMenu = styled.div`
    z-index: 99;
    height: 0;
    display: none;
    overflow: hidden;
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, 0);
    padding: 0 16px;
    border-radius: 8px;
    transition: padding 0.1s ease;
    box-shadow: 0 8px 16px rgba(52, 55, 61, 0.12);
    white-space: nowrap;
  
    &:before {
        content: '';
        background: ${COLORS.white};
        border-radius: 8px;
        top: 6px;
        height: 100%;
        left: 0;
        right: 0;
        position: absolute;
        z-index: 3;
    }
  
    a, span {
        position: relative;
        z-index: 5;
        display: flex;
        margin-bottom: 20px;
        line-height: 1.2;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const Right = styled.div`
    margin-left: auto;
    align-items: center;
    flex-wrap: nowrap;
`;

export const HeaderPhone = styled.a`
    align-self: center;
    color: ${COLORS.black};
    font-size: 12px;
    margin-right: 13px;
    transition: 0.3s color ease;
    white-space: nowrap;
    
    &:hover {
        color: ${COLORS.red};
    }

    @media (max-width: 1279px) and (min-width: 1024px) {
        display: none;
    }

    @media (max-width: ${breakpoints.sDesktop}) {
        margin-left: auto;
        margin-right: 16px;
        font-size: 14px;
        line-height: 1.43;
        color: ${COLORS.darkGrey};
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-left: 0;
        font-size: 12px;
        line-height: 1.67;
    }
`;

export const CallbackLink = styled.div`
    font-size: 14px;
    line-height: 1.43;
    align-items: center;
    color: ${COLORS.darkGrey};

    @media (max-width: 1279px) and (min-width: 1024px) {
        margin-left: auto;
    }

    @media (max-width: ${breakpoints.mobile}) {
        font-size: 12px;
        line-height: 1.67;
    }
`;

export const BurgerIcon = styled.div`
    display: none;

    @media (max-width: ${breakpoints.sDesktop}) {
        display: flex;
        max-width: 14px;
        max-height: 14px;
        margin-left: 25px;
        cursor: pointer;
    }
`;

export const Burger = styled.img``;

export const BurgerMenu = styled.div<{ isAuth: boolean, withPlank: boolean }>`
    position: absolute;
    top: 72px;
    left: 0;
    height: calc(100vh - ${p => p.withPlank ? '144px' : '72px'});
    width: 100%;
    padding: ${p => p.isAuth ? '34px 90px' : '34px 0'};
    background: ${COLORS.lightGrey};
    overflow: hidden;

    @media (max-width: 1024px) {
        padding: ${p => p.isAuth ? '34px 50px' : '34px 0'};
    }

    @media (max-width: ${breakpoints.mobile}) {
        padding: ${p => p.isAuth ? '16px 18px' : '16px 0'};
    }
`;

export const BurgerMenuWrapper = styled(HeaderWrapper)<{ isAuth: boolean }>`
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    gap: 34px;
    height: 100%;
    overflow-y: auto;

    @media (max-width: ${breakpoints.mobile}) {
        height: calc(100% - 32px);
        gap: 24px;
    }
`;

export const BurgerCitySelect = styled.div`
    color: ${COLORS.blue};
    cursor: pointer;
    margin-left: auto;
    align-items: center;

    @media (max-width: ${breakpoints.mobile}) {
        margin-left: 0;
        margin-right: auto;
    }
`;

export const MainMenuRow = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    gap: 20px;

    @media (max-width: ${breakpoints.mobile}) {
        display: flex;
    }
`;
